<template>
  <v-menu :offset-y="true">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon width="60" v-bind="attrs" v-on="on">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item v-for="(item, index) in items" :key="index" @click="click(index)">
        <v-list-item-title>
          {{ item.title }}
          <v-icon v-if="item.lock" size="16px">mdi-lock-outline</v-icon>
        </v-list-item-title>
        <v-spacer></v-spacer>
        <v-icon size="16px" :style="{ opacity: item.selected ? undefined : 0, marginLeft: '4px' }">mdi-check</v-icon>
      </v-list-item>
      <v-list-item v-if="isSignedIn" @click="signOut">
        <v-list-item-title style="color: red"> Sign out</v-list-item-title>
      </v-list-item>
      <v-list-item v-else @click="signIn">
        <v-list-item-title> Sign in </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { firebaseAuth } from '@/services/firebase'

export default {
  data: () => ({
    isSignedIn: null,
    items: [{ title: 'SEA+' }, { title: 'Products' }, { title: 'News' }, { title: 'Shop' }, { title: 'Contact' }]
  }),
  mounted() {
    firebaseAuth.onAuthStateChanged((user) => {
      this.isSignedIn = !!user
    })
  },
  methods: {
    click(index) {
      switch (index) {
        case 0:
          window.location.href = 'https://www.seaplus.style'
          break

        case 1:
          window.location.href = 'https://www.seaplus.style/products'
          break

        case 2:
          window.location.href = 'https://www.seaplus.style/blog'
          break

        case 3:
          this.$router.push('/')
          break

        case 4:
          window.location.href = 'https://www.seaplus.style/contact'
          break
      }
    },
    signIn() {
      this.$router.push('/sign-in')
    },
    signOut() {
      if (confirm('サインアウトしますか?')) {
        this.$router.push('/sign-out')
      }
    }
  }
}
</script>
